<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [style]="{width: '900px', height: '500px'}"
  styleClass="p-fluid p-dialog-intervento-modifica"
  [showHeader]="true"
  header="Modifica Intervento"
  (onHide)="hide()">

  <ng-template pTemplate="header">
    <div class="header-content">
      <span class="material-icons" style="vertical-align: middle; margin-right: 8px; font-size: 28px;">edit</span>
      <span>Modifica l'intervento</span>
      <div class="code-badge" style="background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem;">
        <span class="code-value " style="font-weight: bold; color: #3a6e75;">{{ intervento?.scheda?.codice }}</span>
      </div>
      &nbsp;&nbsp;<span>per l'anno {{ intervento?.richiesta?.anno }}</span>
    </div>
  </ng-template>

  <div class="dialog-container">

    <!-- Contenuto principale -->
    <form [formGroup]="form" class="dialog-content" *ngIf="form">

      <div class="form-group" style="display: flex; gap: 1rem; align-items: flex-start; margin-bottom: 2rem;">
        <div style="flex: 1;">
          <label for="tipoIntervento">Tipo Intervento</label>
          <p-dropdown
            id="tipoIntervento"
            [options]="tipiIntervento"
            optionLabel="descrizione"
            formControlName="tipoIntervento"
            [showClear]="true"
            placeholder="Seleziona il tipo di intervento"
            [style]="{'width': '100%'}"
            [styleClass]="'text-left'">
            <ng-template pTemplate="item" let-tipoIntervento>
              <div [ngStyle]="stiliService.getStileTipoInterventoDropdown(tipoIntervento.id)">
                <i class="material-icons tipo-intervento-badge-icon">
                  {{ stiliService.getIconaTipoIntervento( tipoIntervento.id) }}
                </i>
                <span class="tipo-intervento-badge-value">{{ tipoIntervento.descrizione | uppercase }}</span>
              </div>
            </ng-template>
            <ng-template pTemplate="selectedItem" let-tipoIntervento>
              <div [ngStyle]="stiliService.getStileTipoInterventoDropdown(tipoIntervento.id)" pTooltip="{{ tipoIntervento.descrizione }}" tooltipPosition="top">
                <i class="material-icons tipo-intervento-badge-icon">
                  {{ stiliService.getIconaTipoIntervento( tipoIntervento.id) }}
                </i>
                <span class="tipo-intervento-badge-value">{{ tipoIntervento.descrizione | uppercase }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>

        <div style="flex: 0.6;">
          <label for="priorita">Priorità</label>
          <p-dropdown
            id="priorita"
            [options]="priorita"
            optionLabel="label"
            formControlName="priorita"
            [showClear]="true"
            placeholder="Seleziona la priorità"
            [style]="{'width': '100%'}"
            [styleClass]="'text-left'">
            <ng-template pTemplate="item" let-priorita>
              <div [ngStyle]="stiliService.getStilePrioritaInterventoInForm(priorita.value)" style="text-align: left">
                <i class="material-icons" style="font-size: 18px; margin-right: 4px;">
                  {{ stiliService.getIconaPrioritaIntervento(priorita.value ) }}
                </i>
                <span >{{ priorita.label | uppercase }}</span>
              </div>
            </ng-template>
            <ng-template pTemplate="selectedItem" let-priorita>
              <div [ngStyle]="stiliService.getStilePrioritaInterventoInForm(priorita.value)" style="text-align: left">
                <i class="material-icons" style="font-size: 18px; margin-right: 4px;">
                  {{ stiliService.getIconaPrioritaIntervento(priorita.value ) }}
                </i>
                <span class="ml-2">{{ priorita.label | uppercase }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>

        <div style="flex: 1;">
          <label for="importoRichiesto">Importo Richiesto</label>
          <p-inputNumber
            id="importoRichiesto"
            formControlName="importoRichiesto"
            mode="decimal"
            [min]="0"
            [max]="1000000"
            [showButtons]="true"
            buttonLayout="horizontal"
            spinnerMode="horizontal"
            decrementButtonClass="p-button-secondary"
            incrementButtonClass="p-button-secondary"
            incrementButtonIcon="pi pi-plus"
            decrementButtonIcon="pi pi-minus"
            placeholder="Importo"
            mode="currency"
            currency="EUR"
            locale="it-IT"
            [style]="{'width': '100%', 'text-align': 'right'}"
            [styleClass]="'text-right'"
            [inputStyleClass]="'text-right'">
          </p-inputNumber>
        </div>
      </div>

      <div class="form-group" style="margin-bottom: 2rem;">
        <label for="note">Note</label>
        <textarea
          id="note"
          pInputTextarea
          formControlName="note"
          [rows]="5"
          [autoResize]="true"
          placeholder="Inserisci eventuali note"
          style="width: 100%; min-height: 100px;">
        </textarea>
      </div>
    </form>

    <div class="dialog-footer" style="display: flex; justify-content: flex-end; gap: 0.5rem; width: 50%; margin-left: auto; margin-top: 2rem; margin-bottom: 1rem; padding-right: 1rem;">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        (click)="hide()">
      </button>
      <button
        pButton
        pRipple
        label="Salva"
        icon="pi pi-check"
        class="p-button-success"
        (click)="salvaModifiche()"
        [disabled]="!isFormValid()">
      </button>
    </div>
  </div>
</p-dialog>
<!-- Toast per notifiche -->
<p-toast position="top-right"></p-toast>
